var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerbar"},[_c('span',{staticClass:"copyright"},[_vm._v("Copyright @ "+_vm._s(_vm.systemTitle)+" v"+_vm._s(_vm.systemVersion))])])}
var staticRenderFns = []

export { render, staticRenderFns }